const CHAT_IMAGE_ACCEPT = ".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp";
const CHAT_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
const CHAT_IMAGE_PLACEHOLDER = "[이미지]";
const extensions = Object.freeze({
  "image/jpeg": /\.(?:jpg|jpeg)$/i,
  "image/png": /\.png$/i,
  "image/webp": /\.webp$/i,
});

function validateChatImage(file) {
  if (!file) return "이미지 파일을 선택해주세요.";
  if (!extensions[file.type] || !extensions[file.type].test(String(file.name || ""))) {
    return "JPG, PNG, WEBP 이미지 파일만 첨부할 수 있습니다.";
  }
  if (!Number.isFinite(file.size) || file.size < 1 || file.size > CHAT_IMAGE_MAX_BYTES) {
    return "이미지는 5MB 이하만 첨부할 수 있습니다.";
  }
  return "";
}

function createChatMessagePayload(message, FormDataType) {
  if (!message.image) {
    return { body: message.body, clientMessageId: message.clientMessageId };
  }
  const Payload = FormDataType || FormData;
  const payload = new Payload();
  payload.append("body", message.body);
  payload.append("clientMessageId", message.clientMessageId);
  payload.append("image", message.image, message.image.name);
  return payload;
}

function shouldShowChatBody(message) {
  return Boolean(message && message.body &&
    (!message.attachment || message.body !== CHAT_IMAGE_PLACEHOLDER));
}

module.exports = {
  CHAT_IMAGE_ACCEPT,
  CHAT_IMAGE_MAX_BYTES,
  CHAT_IMAGE_PLACEHOLDER,
  createChatMessagePayload,
  shouldShowChatBody,
  validateChatImage,
};
